const storeToken = (value) => {
  if (value) {
    localStorage.setItem("access", JSON.stringify(value));
  }
};

const storeResponse = (value) => {
  if (value) {
    localStorage.setItem("user_id", value.id);
    localStorage.setItem("name", value.name);
    localStorage.setItem("role", value.role);
  }
};

const getToken = () => {
  let access_token = localStorage.getItem("access");
  let refresh_token = localStorage.getItem("refresh");
  return { access_token, refresh_token };
};

const removeToken = () => {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("name");
  localStorage.removeItem("user_id");
  localStorage.removeItem("role");               // 👈 ADD: clear role too
  localStorage.removeItem("selectedDivision");    // 👈 ADD: clear division
};

// 👇 NEW: Store & Get selected division
const storeDivision = (division) => {
  if (division) {
    localStorage.setItem("selectedDivision", JSON.stringify(division));
  }
};

const getDivision = () => {
  const division = localStorage.getItem("selectedDivision");
  return division ? JSON.parse(division) : null;
};

const removeDivision = () => {
  localStorage.removeItem("selectedDivision");
};

export {
  storeToken,
  getToken,
  removeToken,
  storeResponse,
  storeDivision,    // 👈 NEW
  getDivision,      // 👈 NEW
  removeDivision,   // 👈 NEW
};